<div class="switch" (click)="onValueChange.emit(!value)">
  <input [ngModel]="value" [id]="id" class="switch__input" type="checkbox" />
  <span class="switch__slider"></span>
</div>
